<template>
    <div class="w-100 d-flex flex-column">
        <b-row v-if="$route.name === 'Orders' || $route.name === 'DraftOrders'" align-v="center">
            <b-col>
                <b-nav class="user-panel-nav-tabs">
                    <b-nav-item :to="{name: 'Orders'}"
                                active-class="active">
                        Orders
                    </b-nav-item>
                        <b-nav-item :to="{name: 'DraftOrders'}"
                                    active-class="active">
                        Draft orders
                    </b-nav-item>
                </b-nav>
            </b-col>
            <b-col class="text-right">
                <b-btn class="ml-auto"
                       variant="primary-user"
                       size="sm"
                       :to="{name: 'NewOrder'}">
                    Create a new order
                </b-btn>
            </b-col>
        </b-row>
        <router-view :key="renderKey" @rerender="renderKey++"></router-view>
    </div>
</template>

<script>
    export default {
        name: 'MainOrdersPage',
        data() {
            return {
                renderKey: 0
            }
        },
    }
</script>



// WEBPACK FOOTER //
// src/components/UserPanel/Pages/Orders/MainOrdersPage.vue